import queryString from "query-string";
import { find, has, isEmpty, isString, map } from "lodash";

import { createURL, mergeDeep } from "~/utilities/helpers";

export const translateGatsbyLink = (link, translationProps) => {
    const { location, codeName, englishCode } = translationProps;
    const queryParams = queryString.parse(location.search);

    if (
        !isString(link) ||
        !has(queryParams, codeName) ||
        queryParams[codeName] === englishCode
    ) {
        return link;
    }

    const url = createURL(link);

    if (process.env.GATSBY_SITE_URL !== url.origin) {
        return link;
    }

    const params = queryString.parse(url.search);

    const combinedParams = {
        [codeName]: queryParams[codeName],
        ...params,
    };

    return `${url.pathname}?${queryString.stringify(combinedParams)}${
        url.hash
    }`;
};

export const translateFooter = (translations, translationProps) => {
    const { activeCode, englishCode } = translationProps;

    const englishFooter =
        find(translations, {
            languageCode: englishCode,
        }) || {};

    if (activeCode === englishCode) {
        return englishFooter;
    }

    const translatedFooter =
        find(translations, {
            languageCode: activeCode,
        }) || {};

    return mergeDeep(englishFooter, translatedFooter);
};

export const translateProductTableList = (products, translationProps) => {
    if (translationProps.activeCode === translationProps.englishCode) {
        return products;
    }

    const translatedProducts = map(products, (product) => {
        const productTranslation = find(product.translations, {
            languageCode: translationProps.activeCode,
        });

        if (isEmpty(productTranslation)) {
            return product;
        }

        return {
            ...product,
            title: productTranslation.title,
            slug: `${product.slug}/${productTranslation.languageCode}`,
        };
    });

    return map(translatedProducts, (product) => {
        const productCategory = find(
            product.productCategories?.nodes,
            (category) => !isEmpty(category.ancestors?.nodes),
        );

        if (isEmpty(productCategory)) {
            return product;
        }

        const translation = find(productCategory.translations, {
            languageCode: translationProps.activeCode,
        });

        if (isEmpty(translation)) {
            return product;
        }

        return {
            ...product,
            productCategories: {
                nodes: map(product.productCategories?.nodes, (category) => {
                    if (category.name === productCategory.name) {
                        return {
                            ...category,
                            name: translation.name,
                        };
                    }
                    return category;
                }),
            },
        };
    });
};

export const translatePageBreadcrumbs = (
    translations,
    translationProps,
    nodes,
) => {
    const { activeCode, englishCode } = translationProps;
    const englishTranslation = find(translations, {
        languageCode: englishCode,
    });

    if (activeCode === englishCode || isEmpty(englishTranslation)) {
        return nodes;
    }

    const englishNodes = englishTranslation.ancestors?.nodes;

    return map(englishNodes, (node) => {
        const translatedTitle = find(node.translations, {
            languageCode: activeCode,
        })?.title;

        return {
            ...node,
            title: translatedTitle || node.title,
        };
    });
};
